import { baseURL } from "../config";
import axios from "axios";
const token = sessionStorage.getItem("token");

export const GET = async (path) => {
  try {
    const url = `${baseURL}/api${path}`;
    const res = await axios.get(url, {
      headers: {
        Authorization: token ? "Bearer " + token : "",
      },
    });
    return res;
  } catch (err) {
    return err.response;
  }
};

export const POST = async (path, data) => {
  try {
    const url = `${baseURL}/api${path}`;
    const res = await axios.post(url, data, {
      headers: {
        Authorization: token ? "Bearer " + token : "",
      },
    });
    return res;
  } catch (err) {
    return err.response;
  }
};

export const PUT = async (path, data) => {
  try {
    const url = `${baseURL}/api${path}`;
    const res = await axios.put(url, data, {
      headers: {
        Authorization: token ? "Bearer " + token : "",
      },
    });
    return res;
  } catch (err) {
    return err.response;
  }
};

export const DELETE = async (path) => {
  try {
    const url = `${baseURL}/api${path}`;
    const res = await axios.delete(url, {
      headers: {
        Authorization: token ? "Bearer " + token : "",
      },
    });
    return res;
  } catch (err) {
    return err.response;
  }
};
